import React from 'react';
import './Screen.scss';

import EdgeUpgradeNotice from '../../browsers/EdgeUpgradeNotice/EdgeUpgradeNotice';

export default class Screen extends React.Component {
    render() {
        let className = ['Screen', this.props.className];

        return (
            <div className={className.join(' ')}>
                <EdgeUpgradeNotice />
                <div className="Screen--Header">{this.props.header}</div>
                <div className="Screen--Body">{this.props.children}</div>
                <div className="Screen--Footer">{this.props.footer}</div>
            </div>
        );
    }
}
